import { UUID } from '@macs-frontend/core/utils/uuid';
import {
  CompanyCategory,
  Contact,
  CPO,
  Currency,
  Email,
  Phone,
  Timezone,
} from '@macs-frontend/web-macs/shared';
import { ClientGroup } from './client-group';
import { GeoCity, GeoCountry } from './geo';
import { BaseProject } from './project';
import { BaseSupplier } from './supplier';

export interface BaseClientContact {
  uuid: UUID;
  roleLabel: string;
}

export interface ClientContact extends BaseClientContact {
  contact: Contact;
}

export interface BaseClient {
  name: string;
  btwVat: string;
  logo: string;
  resolvedLogo?: string;
  zip: string;
  language: string;
  address: string;
  address2: string;
  bankAccount: string;
  bic: string;
  status: ClientStatuses;
  invoicedAmount?: number;
  sentInvoicesCount?: number;
  uuid: UUID;
  moreInfo?: string;
  isLinkedToBookkeeping?: boolean;
  country: GeoCountry;
  city: GeoCity;
  defaultDueDateType: string | null;
}

export interface Client extends BaseClient {
  timezone: Timezone;
  category: CompanyCategory;
  currency: Currency;
  projects: BaseProject[];
  contactClientRoles: ClientContact[];
  emails?: Email[];
  phones?: Phone[];
  CPOs: CPO[];
}

export enum ClientStatuses {
  ALL = 'ALL',
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
}

export interface ClientWithGroup {
  client: Client;
  group: ClientGroup;
}

export interface BaseContactClient {
  uuid: UUID;
  roleLabel: string;
}

export interface ContactClient extends BaseContactClient {
  client: BaseClient;
}

export interface BaseContactSupplier {
  uuid: UUID;
  roleLabel: string;
}

export interface ContactSupplier extends BaseContactSupplier {
  supplier: BaseSupplier;
}

export interface SimpleClientForm {
  uuid?: UUID;
  name: string;
  status: ClientStatuses;
  moreInfo?: string;
  btwVat?: string;
  city?: GeoCity;
  country?: GeoCountry;
  zip?: string;
  address?: string;
  defaultDueDateType?: string | null;
}
